import { z } from "zod";

export const forecastDataSchema = z.object({
	timestep: z.string(),
	ww: z.number().optional(),
	temperature_2m: z.number().optional(),
	precipitation_accumulation_3h: z.number().optional(),
	precipitation_accumulation_6h: z.number().optional(),
	precipitation_accumulation_12h: z.number().optional(),
	wind_direction_10m: z.number().optional(),
	wind_speed_10m: z.number().optional(),
	relative_humidity_10m: z.number().optional(),
	air_pollution_index: z.coerce.number().optional(),
	feelLike: z.number().optional(),
});

export const forecastSchema = z.object({
	metadata: z.object({
		station_name_en: z.string(),
		station_name_ar: z.string(),
		station_coordinates: z.string(),
	}),
	data: z.array(forecastDataSchema),
});

export type forecastType = z.infer<typeof forecastSchema>;
export type forecastDataType = z.infer<typeof forecastDataSchema>;
